'use strict';

/*global services*/
/*global createObjectCallBack*/
/*global K2AbstractSetting*/

function K2PrinterSetting() {
  this.lastBarCode = null;

  this.init();
}

K2PrinterSetting.prototype = $.extend({}, K2AbstractSetting.prototype, {
  constructor: 'K2PrinterSetting',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('change', '.printer-setting-form .input-printer-barcode', function () {
      _this.changePrinterBarCode();
      return false;
    });

    $('.open-printer-setting').on('click', function () {
      _this.openPrinterSetting();
      return false;
    });
  },

  //----------------------------------------------------------------------------

  changePrinterBarCode: function changePrinterBarCode() {
    var _this = this;

    var modal = services.get('modal');
    var $content = modal.contentDOM();
    var $form = $content.find('form');
    var barCode = $.trim($form.find('[name$="[BarCode]"]').val());

    if (barCode) {
      if (_this.lastBarCode !== barCode) {
        _this.lastBarCode = barCode;
        modal.block();
        $.get(services.get('router').path('load_printer_group_by_barcode', { BarCode: barCode }), function (res) {
          modal.unBlock();
          if (res.msg === 'SUCCESS') {
            modal.contentDOM().find('.printer-info').html(res.data.html);
          } else {
            services.get('notifications').viewErrorMessage();
          }
        });
      }
    }

    return _this;
  },

  initPrinterSettingFrom: function initPrinterSettingFrom() {
    var _this = this;

    //var modal = services.get('modal');
    _this.lastBarCode = null;

    return _this;
  },

  submitPrinterSettingFrom: function submitPrinterSettingFrom(callback) {
    var _this = this;

    var modal = services.get('modal');
    var $content = modal.contentDOM();
    var $form = $content.find('form');

    modal.block();
    $.post($form.attr('action'), $form.serialize(), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.close();

        _this.updateSettingButton(res.data.printer_group, 'open-printer-setting');

        if (services.has('configurations')) {
          services.get('configurations').setParam('printer_group', res.data.printer_group);
        }

        services.get('notifications').viewSaveMessage();

        if ($.isFunction(callback)) {
          callback(res.data.printer_group);
        }
      } else if (res.msg === 'NOT_VALID') {
        modal.content(res.data.html);
        _this.initPrinterSettingFrom();
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  openPrinterSetting: function openPrinterSetting(callback) {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('printer.setting'),
      height: 'auto',
      width: 'md',
      modalClass: 'printer-setting-form',
      submitCallBack: createObjectCallBack(_this, 'submitPrinterSettingFrom', callback),
      enterSubmitCallBack: createObjectCallBack(_this, 'changePrinterBarCode'),
      form: true,
      keyboardClose: false
    });

    modal.block();
    $.get(services.get('router').path('printer_setting'), function (res) {
      modal.unBlock();
      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
        _this.initPrinterSettingFrom();
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
